import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../abstraction/auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataLayerService } from '../../../services/utils/data-layer.service';

@Component({
  selector: 'app-withdraw-tab',
  templateUrl: './withdraw-tab.component.html',
  styleUrls: ['./withdraw-tab.component.scss'],
})
export class WithdrawTabComponent implements OnInit, OnDestroy {
  loading: boolean;
  pesoAdolar: boolean;
  amount: string;

  constructor(
    private apiService: ApiService,
    public authService: AuthService,
    public dialog: MatDialog,
    public dataService: DataLayerService,
    public dialogRef: MatDialogRef<WithdrawTabComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: string,
  ) {}

  ngOnInit() {
    // this.pesoAdolar = true;
    // this.loading = false;
    // this.amount = '0 AR$';
    if (this.data === 'ARS-withdraw') {
      this.dataService.withdrawStep = 1;
      this.dataService.withdrawType = 1;
    } else if (this.data === 'USD-withdraw') {
      this.dataService.withdrawStep = 1;
      this.dataService.withdrawType = 0;
    } else if (this.data !== undefined || this.data != null) {
      this.dataService.withdrawStep = 2;
      this.dataService.withdrawType = this.data === 'ars' ? 1 : 0;
    } else {
      this.dataService.withdrawStep = 0;
      this.dataService.withdrawType = null;
    }

    this.authService.refreshFiatStatus();
  }

  ngOnDestroy() {
    this.dataService.withdrawStep = 0;
    this.dataService.withdrawType = null;
  }

  changeCloseDialog(event) {
    this.dialogRef.disableClose = event;
    this.dialogRef.updatePosition();
  }
}
